module.exports = __webpack_public_path__ + "components/MapControl/svg/Schronisko turystyczne.svg?be9e620f";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Schronisko turystyczne.svg
// module id = 2036
// module chunks = 0